var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.1894 9.11987V13.7865M14.1894 18.4532H14.201M12.1944 3.1232L2.31269 19.6199C2.10895 19.9727 2.00115 20.3727 2.00001 20.7801C1.99887 21.1876 2.10443 21.5882 2.30619 21.9421C2.50794 22.2961 2.79887 22.5911 3.15001 22.7977C3.50116 23.0043 3.90029 23.1154 4.30769 23.1199H24.071C24.4784 23.1154 24.8775 23.0043 25.2287 22.7977C25.5798 22.5911 25.8708 22.2961 26.0725 21.9421C26.2743 21.5882 26.3798 21.1876 26.3787 20.7801C26.3776 20.3727 26.2698 19.9727 26.066 19.6199L16.1844 3.1232C15.9764 2.78033 15.6835 2.49684 15.3341 2.3001C14.9846 2.10336 14.5904 2 14.1894 2C13.7883 2 13.3941 2.10336 13.0446 2.3001C12.6952 2.49684 12.4023 2.78033 12.1944 3.1232Z",
    stroke: "#D92D20",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.3106a7a0c42755c879f878a59b7709ef.svg";
export { ForwardRef as ReactComponent };